import type { So_RemoteCreateUserListMutation } from '@shared/gql/sostoslista-document-nodes'

import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'
import { ModalService } from 'services/Modal'
import { Notifications } from 'services/Notifications'
import { addSnackbar } from 'services/Snackbar/Snackbars'

import { EditListModal } from '../EditListModal'
import { paths } from '../paths'
import { useCreateUserListQuery } from '../queries/use-create-list'

export const useCreateNewList = (storeId: string) => {
  const { t } = useTranslation()
  const createList = useCreateUserListQuery(storeId)
  const router = useRouter()

  return () =>
    new Promise<NonNullable<So_RemoteCreateUserListMutation['createShoppingList']>>(
      (resolve, reject) => {
        ModalService.open<string>(<EditListModal title={t('Create new shopping list')} />, {
          onSubmit: async (name) => {
            // rejecting inside would otherwise result in uncaught error
            try {
              const response = await createList(name)
              if (!response.data || !response.data.createShoppingList) {
                throw new Error('Response data was empty')
              }
              const result = response.data.createShoppingList

              addSnackbar({
                text: t('New list created', { name }),
                actionText: t('Goto new list'),
                onAction: () => router.push(paths.list(result.id || '')),
              })
              // Mark notificiation dismissed so that we don't trigger it.
              Notifications.dismiss('shoppinglist-intro-notification')
              resolve(result)
            } catch (e) {
              reject(e)
            }
          },
        })
      },
    )
}
